import { IconPlaceholderImages24 } from '@cian/ui-kit/icons';
import classNames from 'clsx';
import * as React from 'react';

import * as styles from './Stub.css';
import { IPessimization } from '../../../../types';
import { Pessimization } from '../Pessimization';

export interface IStubProps {
  pessimization?: IPessimization;
  slotEnd?: React.ReactNode;
}

const StubComponent = ({ pessimization, slotEnd }: IStubProps) => {
  const component = React.useMemo(
    () => (
      <div className={classNames(styles['container'], { [styles['container--pessimized']]: !!pessimization })}>
        {!pessimization && (
          <div className={styles['placeholder']}>
            <IconPlaceholderImages24 color="gray20_100" />
          </div>
        )}
        {slotEnd}
      </div>
    ),
    [pessimization, slotEnd],
  );

  if (pessimization) {
    return <Pessimization pessimization={pessimization}>{component}</Pessimization>;
  }

  return component;
};

export const Stub = React.memo(StubComponent);
